export type ProductVideoProvider = 'youtube' | 'loom' | 'vimeo'

export interface ProductVideoEmbed {
  provider: ProductVideoProvider
  embedUrl: string
}

/** Same rules as the backend `productVideoProvider` (checked by `productExtras.test.ts`). */
export function productVideoEmbed(raw: unknown): ProductVideoEmbed | null {
  let url: URL
  try {
    url = new URL(String(raw ?? '').trim())
  } catch {
    return null
  }
  if (url.protocol !== 'https:' && url.protocol !== 'http:') return null
  const host = url.hostname.toLowerCase().replace(/^(www|m)\./, '')
  const path = url.pathname.split('/').filter(Boolean)

  if (host === 'youtu.be' || host === 'youtube.com' || host === 'youtube-nocookie.com') {
    const id = host === 'youtu.be'
      ? path[0]
      : path[0] === 'watch'
        ? url.searchParams.get('v')
        : ['embed', 'shorts', 'live'].includes(path[0] ?? '') ? path[1] : null
    if (!id || !/^[\w-]{11}$/.test(id)) return null
    return { provider: 'youtube', embedUrl: `https://www.youtube-nocookie.com/embed/${id}` }
  }
  if (host === 'loom.com') {
    const id = ['share', 'embed'].includes(path[0] ?? '') ? path[1] : null
    if (!id || !/^[0-9a-f]{32}$/i.test(id)) return null
    return { provider: 'loom', embedUrl: `https://www.loom.com/embed/${id}` }
  }
  if (host === 'vimeo.com' || host === 'player.vimeo.com') {
    const id = host === 'vimeo.com' ? path[0] : path[0] === 'video' ? path[1] : null
    if (!id || !/^\d+$/.test(id)) return null
    return { provider: 'vimeo', embedUrl: `https://player.vimeo.com/video/${id}` }
  }
  return null
}
